// extracted by mini-css-extract-plugin
export default {"avatarText":"User_avatarText__JN9iH","cutText":"User_cutText__G5E6k","userMenuBlock":"User_userMenuBlock__V8qoT"};